import { takeEvery, fork, put, all } from 'redux-saga/effects';
import * as actionType from './actionTypes';
import { api } from 'api';
import { AxiosResponse } from 'axios';
import { apiResError } from '../actions';
import { Constant } from 'api';
import { setPriceListDefault } from './actions';
import { PRICE_LIST } from '../../config/global';

function* sagaGetPriceListDefault() {
	try {
		const response: AxiosResponse<Constant> =
			yield api.calculation.apiCalculationDataConstantByNameGet(
				PRICE_LIST
			);
		if (response.data) {
			console.log('saga', response.data.matrix);
			yield put(setPriceListDefault(response.data.matrix));
		}
	} catch (error: any) {
		yield put(apiResError(error.message));
	}
}

export function* watchSagaGetPriceListDefault() {
	yield takeEvery(actionType.GET_PRICE_LIST_DEFAULT, sagaGetPriceListDefault);
}

function* priceListSaga() {
	yield all([fork(watchSagaGetPriceListDefault)]);
}

export default priceListSaga;
